import type { IEmailCampaignDesignStatus } from "api/rpc/2024-04/facilityAdmin/marketing/emailBuilderTypes";
import {
  resolveEmailBuilderReturnTo as resolveWorkspaceReturnTo,
  type TEmailBuilderWorkspace,
} from "./emailBuilderWorkspace";
import {
  resolveEmailBuilderCampaignEntryDestination,
  type TEmailBuilderCampaignEntryDestination,
} from "./emailBuilderCampaignEntry";

export type { TEmailBuilderLocationState } from "./emailBuilderWorkspace";
export {
  emailCampaignBuilderPath,
  emailCampaignBuilderReturnPath,
  emailCampaignSelectTemplatePath,
  emailTemplateBuilderPath,
  emailTemplateLibraryPath,
} from "./emailBuilderWorkspace";

export type TEmailBuilderLaunchSource = "create" | "edit";

export type TPrepareEmailCampaignBuilderLaunchResult =
  | { ok: true; destination: TEmailBuilderCampaignEntryDestination }
  | { ok: false; message: string };

type TDesignStatusResponse = {
  status: number;
  data: IEmailCampaignDesignStatus | null;
  message: string;
};

export function resolveEmailBuilderReturnTo(campaignId: number, locationState: unknown): string {
  const workspace: TEmailBuilderWorkspace = { kind: "campaign", id: campaignId };
  return resolveWorkspaceReturnTo(workspace, locationState);
}

export async function prepareEmailCampaignBuilderLaunch(options: {
  campaignId: number;
  savePrerequisites: () => Promise<boolean>;
  getDesignStatus: (campaignId: number) => Promise<TDesignStatusResponse>;
}): Promise<TPrepareEmailCampaignBuilderLaunchResult> {
  const saved = await options.savePrerequisites();
  if (!saved) {
    return { ok: false, message: "" };
  }

  const designRes = await options.getDesignStatus(options.campaignId);
  if (designRes.status !== 200) {
    return {
      ok: false,
      message:
        designRes.message.length > 0
          ? designRes.message
          : "Could not load email campaign design status.",
    };
  }

  return {
    ok: true,
    destination: resolveEmailBuilderCampaignEntryDestination(designRes.data),
  };
}
